import { useQuery } from '@tanstack/react-query';
import { getActions, ActionsResponse } from '../api/actions';

/**
 * Custom hook for fetching actions
 * Uses TanStack Query for data fetching and caching
 */
export const useActions = () => {
  // Use query for fetching
  const query = useQuery({
    queryKey: ['actions'],
    queryFn: () => getActions(),
    staleTime: 300000, // 5 minutes
  });
  
  // Get actions from query data
  const actions = query.data?.actions ?? [];
  
  return {
    ...query,
    actions
  };
}; 